module.exports = __webpack_public_path__ + "img/DSC_0006.1ccaa77b.jpg";